
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const TRADE_IN_HOST =
  currentEnv !== 'prod'
    ? 'https://customizer.dev.col.movistar.es/v2/api/trade-in'
    : 'https://customizer.col.movistar.es/v2/api/trade-in';
    
export const PROCESS_NAME = 'ADABYRON-API';

export const GET_DEVICES_PAYLOAD = {
  type: null,
  brand: null,
  model: null,
  serie: null,
  capacity: null,
  search: '',
  pdv: 3,
  pricing: {
    policy: 'percentage',
    percentages: [
      {
        'grade_A+': 1,
      },
      {
        grade_A: 0,
      },
      {
        grade_B: 0,
      },
      {
        grade_C: 0,
      },
      {
        grade_D: 0,
      },
      {
        grade_E: 0,
      },
    ],
  },
  page: 1,
  page_size: 50,
};